import { TextKey } from '@mews-commander/enums';
import { LocalizedLabel } from '@mews-commander/ui';
import { CornerCellElement } from '../../../../../components/commander-ui/Matrix';

export const BlockSetupMatrixCornerCell = (props: { height: string }) => (
    <CornerCellElement {...props}>
        <LocalizedLabel textKey={TextKey.SpaceCategory} as="div" />
    </CornerCellElement>
);
